__turbopack_context__.v({
  "className": "C8KRYq_className",
  "variable": "C8KRYq_variable",
});
